import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FilterDTO, PagedResultDTOOfParkingCardDTO, ParkingCardClient, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';
import { FilterUtil } from 'src/app/base/shared/filter-util';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

@Injectable({
  providedIn: 'root'
})

export class ParkingCardService extends ShowInactiveService implements IAdaptorService {

  public issuedToMe: boolean = false;

  constructor(private parkingCardClient: ParkingCardClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfParkingCardDTO> {
    if (!sortBy) {
      sortBy = this.issuedToMe ? 'VisitorAlias' : 'ParkerAlias';
      sortDirection = SortDirection.Ascending;
    } else if (sortBy === "IssuingParkerName") {
      sortBy = 'IssuingParker.FirstName';
    } else if (sortBy === "IssuedToUserName") {
      sortBy = 'IssuedToUser.Firstname';
    } else if (sortBy === "ClientName") {
      sortBy = 'Client.Name';
    }
    // check if filters contains issuingParkerName, issuedToUserName or clientName, then change them to dot notation
    FilterUtil.replaceFieldNameInfilters(filters, 'IssuingParkerName', 'IssuingParker.FirstName');
    FilterUtil.replaceFieldNameInfilters(filters, 'IssuedToUserName', 'IssuedToUser.Firstname');
    FilterUtil.replaceFieldNameInfilters(filters, 'ClientName', 'Client.Name');

    FilterUtil.correctDateTimeFilters(filters, 'ValidFromDateTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    FilterUtil.correctDateTimeFilters(filters, 'ValidToDateTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    FilterUtil.correctDateTimeFilters(filters, 'LastUsedOn', DATE_HELPER_DEFAULT_TIME_ZONE);

    this.spinnerService.showSpinner = true;
    return this.parkingCardClient.searchParkingCards(filters, skip, take, sortBy, sortDirection, this.issuedToMe)
      .pipe(
        tap((result) => {
          this.spinnerService.showSpinner = false;
          result.items ??= [];
        }),
        catchError(err => {
          this.spinnerService.showSpinner = false;
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message');
          return throwError(() => err);
        }));
  }

  public addRecord(_data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public updateRecord(_data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public deleteRecord(_id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public revokeParkingCard(parkingCardId: number): Observable<any> {
    this.spinnerService.showSpinner = true;
    return this.parkingCardClient.revokeParkingCard(parkingCardId)
      .pipe(
        tap(() => {
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess(
            'i18n.domain.parking-card.messages.revoke-title',
            'i18n.domain.parking-card.messages.revoke-success-message'
          );
        }),
        catchError(err => {
          this.spinnerService.showSpinner = false;
          this.toastService.showError(
            'i18n.errors.server-error.title',
            'i18n.errors.server-error.message');
          return throwError(() => err);
        }));
  }
}
